// extracted by mini-css-extract-plugin
module.exports = {"parentIcon":"FilterIcons_parentIcon__4L1K5","childIcon":"FilterIcons_childIcon__ZMsIH","skeleton-loading":"FilterIcons_skeleton-loading__MLdMQ"};